import { Chip, Stack, Typography, useTheme } from '@mui/material';
import { ONBOARDING_PAGE_NS } from '../i18n';
import { useTranslation } from 'react-i18next';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import { useOnboardingStore } from '@diana/core';

const AreaChip = ({
  area,
  isActive = false,
  showAiIcon = false,
}: {
  area: string;
  isActive?: boolean;
  showAiIcon?: boolean;
}) => {
  const { palette } = useTheme();

  const setSelectedKeyAreas = useOnboardingStore((store) => store.setKeyAreas);
  const contrastText = palette.getContrastText(palette.primary.main);

  return (
    <Chip
      onClick={() => setSelectedKeyAreas(area)}
      label={area}
      clickable={false}
      icon={
        showAiIcon ? (
          <ElectricBoltOutlinedIcon
            sx={{
              width: 16,
              height: 16,
              color: `${isActive ? contrastText : palette.primary.main} !important`,
              transition: 'color 0.3s',
            }}
          />
        ) : undefined
      }
      sx={{
        userSelect: 'none',
        cursor: 'pointer',
        height: 'auto',
        borderRadius: 80,
        backgroundColor: isActive ? palette.primary.main : palette.background.paperLowElevation,
        borderColor: isActive ? palette.primary.main : palette.secondary.muted,
        color: isActive ? contrastText : palette.text.primary,
        transition: '0.3s',
        '& > .MuiChip-label': { px: 1, py: 0.5, fontSize: 14 },
      }}
    />
  );
};

export const BusinessKeyAreas = () => {
  const { palette } = useTheme();
  const { t } = useTranslation(ONBOARDING_PAGE_NS);

  const selectedkeyAreas = useOnboardingStore((store) => store.keyAreas);
  const aiAreas = useOnboardingStore((store) => store.aiAreas);

  const keyAreas = [
    t('keyAreas.supply.area'),
    t('keyAreas.asset.area'),
    t('keyAreas.logistics.area'),
    t('keyAreas.operations.area'),
    t('keyAreas.compliance.area'),
    t('keyAreas.sustainability.area'),
    t('keyAreas.human.area'),
    t('keyAreas.customer.area'),
    t('keyAreas.other.area'),
  ];

  return (
    <Stack gap={4}>
      <Stack gap={0.5}>
        <Typography variant="h2">{t('steps.keyAreas.component.title')}</Typography>
        <Typography color={palette.text.secondary}>
          {t('steps.keyAreas.component.description')}
        </Typography>
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {keyAreas.map((area, index) => {
          const isActive = selectedkeyAreas.includes(area);
          return <AreaChip key={`key-area-${index}`} isActive={isActive} area={area} />;
        })}
      </Stack>
      <Stack gap={2}>
        <Typography variant="h4">{t('steps.keyAreas.component.suggestions')}</Typography>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {aiAreas.map((area, index) => {
            const isActive = selectedkeyAreas.includes(area);
            return (
              <AreaChip key={`key-area-ai-${index}`} isActive={isActive} area={area} showAiIcon />
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
};
